import { render } from "./P023.vue?vue&type=template&id=3aa3aeee&scoped=true"
import script from "./P023.vue?vue&type=script&lang=js"
export * from "./P023.vue?vue&type=script&lang=js"

import "./P023.vue?vue&type=style&index=0&id=3aa3aeee&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa3aeee"]])

export default __exports__